// extracted by mini-css-extract-plugin
module.exports = {"highTopMargin":"rG","lowTopMargin":"rH","rightColumnWrapper":"rI","rightColumnTitle":"rJ","title":"rK"};